"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Sentry = require("@sentry/browser");
var data_scrubber_1 = require("./data_scrubber");
var integrations_1 = require("@sentry/integrations");
var defaults_1 = require("./defaults");
var originalInitFn = Sentry.init;
var init = function (options) {
    var _a;
    if ((options === null || options === void 0 ? void 0 : options.allowUrls) === undefined) {
        throw new Error("Sentry.init: Missing 'allowUrls' option");
    }
    var userIntegrations = options === null || options === void 0 ? void 0 : options.integrations;
    var ourIntegrationFn = function (integrations) {
        var _integrations = integrations.filter(function (integration) {
            return integration.name !== Sentry.Integrations.Breadcrumbs.name;
        });
        _integrations.push(new integrations_1.Dedupe());
        _integrations.push(new data_scrubber_1.default({
            sanitizeKeys: defaults_1.defaultKeysToSanitize,
        }));
        if (Array.isArray(userIntegrations)) {
            _integrations = _integrations.concat(userIntegrations);
        }
        if (userIntegrations instanceof Function) {
            _integrations = userIntegrations(_integrations);
        }
        return _integrations;
    };
    return originalInitFn.call(Sentry, __assign(__assign({ allowUrls: ["block_all"] }, options), { integrations: ourIntegrationFn, autoSessionTracking: false, ignoreErrors: defaults_1.defaultErrorsToIgnore.concat((_a = options === null || options === void 0 ? void 0 : options.ignoreErrors) !== null && _a !== void 0 ? _a : []) }));
};
exports.default = __assign(__assign({}, Sentry), { init: init });
//# sourceMappingURL=index.js.map